"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_helmet_1 = require("react-helmet");
const Meta = ({ meta }) => (React.createElement(react_helmet_1.Helmet, null,
    React.createElement("title", null, meta.title),
    React.createElement("meta", { name: 'description', content: meta.description }),
    React.createElement("meta", { property: 'og:title', content: meta.title }),
    React.createElement("meta", { property: 'og:description', content: meta.description }),
    React.createElement("meta", { property: 'og:image', content: meta.image.file.url })));
exports.default = Meta;



// WEBPACK FOOTER //
// ./src/components/meta.tsx